import { domainToProfileIdOptionsMap } from '@/contentprofile/domain_content_profiles'

const DISABLED_THREADS_DOMAIN_NAME_PATTERNS = ['CPS Network', 'Chicago Public Schools (SD 299) (IL)','Jovita Idar Elementary (IL)','Alain Locke Charter School (IL)','Catalyst Circle Rock Elementary School (IL)','Catalyst Schools (IL)','Distinctive Schools (IL)','Great Lakes Academy Charter School (Chicago IL)','KIPP Chicago (IL)','LEARN Charter School Network (IL)','Legacy Elementary Charter School (IL)','Nancy B. Jefferson Alternative High School (Chicago IL)','Perspectives Charter Schools (IL)','Providence Englewood Charter School (IL)','ReGeneration Schools (IL)','Youth Connection Charter School (Chicago IL)','Oscar Mayer Magnet School (IL)','King Academy of Social Justice (CPS)(IL)','Ogden International High School (IL)','Bulls College Prep (IL)','Gary Comer Middle School (IL)','UChicago Charter Woodlawn Campus (University of Chicago Charter School (IL))']

export default {
  namespaced: true,
  state: {
    betaMode: false,
    editorMode: false,
    iodMode: null,
    analyticsDashboardMode: null,
    effectsMode: null,
    shareMode: null,
    threadsMode: null,
    orientationMobilityMode: null,
    disabledThreadsDomains: DISABLED_THREADS_DOMAIN_NAME_PATTERNS,
  },
  mutations: {
    toggleBetaMode(state, flag) {
      state.betaMode = flag
    },
    toggleEditorMode(state, flag) {
      state.editorMode = flag
    },
    toggleIodMode(state, flag) {
      state.iodMode = flag
    },
    toggleAnalyticsDashboardMode(state, flag) {
      state.analyticsDashboardMode = flag
    },
    toggleEffectsMode(state, flag) {
      state.effectsMode = flag
    },
    toggleShareMode(state, flag) {
      state.shareMode = flag
    },
    toggleThreadsMode(state, flag) {
      state.threadsMode = flag
    },
    toggleOrientationMobilityMode(state, flag) {
      state.orientationMobilityMode = flag
    },
  },
  actions: {
    enableBetaMode({ commit }) {
      commit('toggleBetaMode', true);
    },
  },
  getters: {
    editorVisibility(state, getters, rootState, rootGetters) {
      return state.editorMode && rootGetters['user/isSuperAdmin']
    },
    betaVisibility(state, getters, rootState, rootGetters) {
      return state.betaMode && rootGetters['user/isAuthenticated']
    },
    teksVisibility(state, getters, rootState, rootGetters) {
      return rootGetters['user/isTeks'] || rootGetters['contentProfile/profileId'] == 'texas'
    },
    selVisibility(state, getters, rootState, rootGetters) {
      const profileId = rootGetters['contentProfile/profileId'] || ''
      return !profileId.endsWith('no_SEL')
    },
    iodVisibility(state, getters, rootState, rootGetters) {
      if (state.iodMode !== null) return state.iodMode
      // check if the content profile is one that doesn't allow IOD feature
      // no-iod-test profile is used for cypress testing
      const noIODProfiles = ['nevada-no-iod', 'no-iod-test']
      return noIODProfiles.indexOf(rootGetters['contentProfile/profileId']) == -1
    },
    analyticsDashboardVisibility(state, getters, rootState, rootGetters) {
      if (state.analyticsDashboardMode !== null) return state.analyticsDashboardMode
      const domainFlags = rootGetters['user/domainInfo']?.flags || []
      return domainFlags.includes('analytics_dashboard')
    },
    effectsVisibility(state, getters, rootState, rootGetters) {
      if (state.effectsMode !== null) return state.effectsMode
      // check if the content profile is one that has effect statements in PLW
      const effectsProfiles = ['nevada-no-iod']
      return effectsProfiles.indexOf(rootGetters['contentProfile/profileId']) > -1
    },
    isCCSDProfile(state, getters, rootState, rootGetters) {
      return rootGetters['contentProfile/profileId'] === 'nevada-no-iod'
    },
    shareVisibility(state, getters, rootState, rootGetters) {
      if (state.shareMode !== null) return state.shareMode
      // check if the content profile is one that doesn't allow share feature
      const profileId = rootGetters['contentProfile/profileId'] || ''
      // profiles where share is disabled
      const noShareProfiles = new Set(['florida_no_share_no_SEL'])
      return !noShareProfiles.has(profileId)
    },
    threadsVisibility(state, getters, rootState, rootGetters) {
      if (state.threadsMode !== null) return state.threadsMode
      const isAuthenticated = rootGetters['user/isAuthenticated']
      if (!isAuthenticated) return false

      const userDomainName = rootGetters['user/domainInfo']?.name || ''
      const belongsToDisabledDomain = state.disabledThreadsDomains.some(domain => userDomainName.includes(domain))

      const domainFlags = rootGetters['user/domainInfo']?.flags || []
      const hasNoThreadsFlag = domainFlags.includes('no_threads')

      const profileId = rootGetters['contentProfile/profileId'] || ''
      const hasNoAIProfile = profileId.endsWith('no-ai')

      return !belongsToDisabledDomain && !hasNoThreadsFlag && !hasNoAIProfile
    },
    canChangeProfile(state, getters, rootState, rootGetters) {
      const userDomainUuid = rootGetters['user/userDomainUuid']
      return new Set(Object.keys(domainToProfileIdOptionsMap)).has(userDomainUuid)
    },
    orientationMobilityVisibility(state, getters, rootState, rootGetters) {
      if (state.orientationMobilityMode !== null) return state.orientationMobilityMode
      // Default to false - O&M category is hidden by default
      return false
    },
    aiFeatureVisibility(state, getters, rootState, rootGetters) {
      const profileId = rootGetters['contentProfile/profileId'] || ''
      const noAIProfiles = new Set(['new-york_no-ai'])
      return !noAIProfiles.has(profileId)
    },
    growVisibility(state, getters, rootState, rootGetters) {
      const domainFlags = rootGetters['user/domainInfo']?.flags || []
      return domainFlags.includes('grow_access') || !!rootGetters['user/hasGrowAccessTag']
    },
  },
}
